import { render, staticRenderFns } from "./TaskUpdateEndDate.vue?vue&type=template&id=5cb2fa62&scoped=true"
import script from "./TaskUpdateEndDate.vue?vue&type=script&lang=js"
export * from "./TaskUpdateEndDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2fa62",
  null
  
)

export default component.exports